import { FactList, PanelCard, QuietEmpty, SectionHeader } from '../../../components/project/ui';
import { useProject } from '../ProjectContext';

const repoKindLabel: Record<string, string> = {
  site: 'Whole WordPress site (core committed)',
  composer: 'Composer-managed site',
  bedrock: 'Bedrock site',
  wp_content: 'wp-content directory',
  theme: 'One theme',
  plugin: 'One plugin',
  plugins: 'Several plugins',
};

const unitKindLabel: Record<string, string> = {
  theme: 'Theme',
  plugin: 'Plugin',
  mu_plugin: 'Must-use plugins',
};

/**
 * WordPressRepositoryCard states what the repository is and what a
 * deployment replaces on the server, as read from the repository itself the
 * last time a deployment was planned — never assumed from the project type.
 */
export function WordPressRepositoryCard() {
  const project = useProject();
  const app = project.applications.find((application) => application.type === 'wordpress');
  const detection = project.wordpressSite.data?.repository_detection;

  return (
    <PanelCard labelledBy="wp-repo-title" testId="wordpress-repository">
      <SectionHeader id="wp-repo-title" title="Repository" />
      <FactList
        facts={[
          {
            label: 'Repository',
            value: project.project.repository_url ? <code>{project.project.repository_url}</code> : <span className="muted">None</span>,
          },
          {
            label: 'Branch',
            value: app?.default_branch ? <code>{app.default_branch}</code> : <span className="muted">Default</span>,
          },
          {
            label: 'Layout',
            value: detection ? (detection.is_wordpress ? repoKindLabel[detection.kind ?? ''] ?? detection.kind : 'Not recognised as WordPress code') : <span className="muted">Not read yet</span>,
          },
        ]}
      />
      {detection?.units?.length ? (
        <ul className="status-list status-list--stacked" aria-label="What a deployment replaces">
          {detection.units.map((unit) => (
            <li key={`${unit.kind}:${unit.slug}`} className="status-list__item">
              <span className="status-list__name">{unit.name || unit.slug}</span>
              <span className="status-list__detail muted">
                {unitKindLabel[unit.kind] ?? unit.kind} · <code>{unit.source_path}</code> → <code>wp-content/{unit.target_path}</code>
              </span>
            </li>
          ))}
        </ul>
      ) : detection ? (
        <QuietEmpty>No theme or plugin directory to deploy</QuietEmpty>
      ) : null}
      {(detection?.warnings ?? []).map((warning) => (
        <p key={warning} className="panel__note muted">
          {warning}
        </p>
      ))}
    </PanelCard>
  );
}
